/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useEffect } from "react";
import { useDeviceSelectors } from "react-device-detect";


export default function BrowserDetails({
  setDeviceDetails,
}) {
  const [selectors] = useDeviceSelectors(window?.navigator?.userAgent);

  useEffect(() => {
    const { osName, osVersion, browserName, browserVersion, deviceType } =
      selectors;

    setDeviceDetails({
      os: osName,
      osVersion: osVersion,
      browser: browserName,
      browserVersion: browserVersion,
      deviceType,
    });
  }, []);

  return <></>;
}